import { useState } from 'react';
import { KeyboardDatePicker as MUIKeyboardDatePicker } from '@material-ui/pickers';

export function KeyboardDatePicker({ onChange, variant, ...others }) {
  const [isOpen, setIsOpen] = useState(false);
  return variant === 'inline' ? (
    <MUIKeyboardDatePicker
      {...others}
      variant={variant}
      onChange={(newDate) => {
        if (typeof onChange === 'function') {
          onChange(newDate);
          setIsOpen(false);
        }
      }}
      KeyboardButtonProps={{
        onFocus: (e) => {
          setIsOpen(true);
        },
      }}
      PopoverProps={{
        disableRestoreFocus: true,
        onClose: () => {
          setIsOpen(false);
        },
      }}
      InputProps={{
        onFocus: () => {
          setIsOpen(true);
        },
      }}
      open={isOpen}
    />
  ) : (
    <MUIKeyboardDatePicker onChange={onChange} variant={variant} {...others} />
  );
}
